import { hasCreatorAccess } from "./roleUtils";

/**
 * Profile URL for a user document — fans → /fan/:uid, creators → /creator/:handle.
 */
export function getUserProfilePath(user) {
  if (!user?.uid && !user?.id) return null;
  const uid = user.uid || user.id;

  if (hasCreatorAccess(user)) {
    const handle = user.handle || user.username;
    return handle ? `/creator/${handle}` : `/fan/${uid}`;
  }

  return `/fan/${uid}`;
}

export function getFanProfileEditPath(userId) {
  if (!userId) return "/profile/edit";
  return `/fan/${userId}/edit`;
}

/** Creator storefront from a handle (drops, moments, vault, lightbox). */
export function getCreatorProfilePathFromHandle(handle, uid) {
  const h = String(handle || "").replace(/^@/, "").trim();
  if (h) return `/creator/${h}`;
  if (uid) return `/fan/${uid}`;
  return null;
}

export function getDropPath(id) {
  return id ? `/drop/${id}` : null;
}

/**
 * Avatar click destination from partial user fields (comments, viewer lists, etc.).
 */
export function getAvatarProfilePath({ uid, userId, id, isCreator, handle, username } = {}) {
  const resolvedId = uid || userId || id;
  if (!resolvedId) return null;

  if (isCreator) {
    const h = handle || username;
    return h ? `/creator/${h}` : `/fan/${resolvedId}`;
  }

  return `/fan/${resolvedId}`;
}
